/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateUserNotificationSetting200ResponseAllOfData } from './UpdateUserNotificationSetting200ResponseAllOfData';
import {
    UpdateUserNotificationSetting200ResponseAllOfDataFromJSON,
    UpdateUserNotificationSetting200ResponseAllOfDataFromJSONTyped,
    UpdateUserNotificationSetting200ResponseAllOfDataToJSON,
} from './UpdateUserNotificationSetting200ResponseAllOfData';

/**
 * 
 * @export
 * @interface UpdateUserNotificationSetting200Response
 */
export interface UpdateUserNotificationSetting200Response {
    /**
     * 
     * @type {UpdateUserNotificationSetting200ResponseAllOfData}
     * @memberof UpdateUserNotificationSetting200Response
     */
    data: UpdateUserNotificationSetting200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof UpdateUserNotificationSetting200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the UpdateUserNotificationSetting200Response interface.
 */
export function instanceOfUpdateUserNotificationSetting200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function UpdateUserNotificationSetting200ResponseFromJSON(json: any): UpdateUserNotificationSetting200Response {
    return UpdateUserNotificationSetting200ResponseFromJSONTyped(json, false);
}

export function UpdateUserNotificationSetting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNotificationSetting200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': UpdateUserNotificationSetting200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function UpdateUserNotificationSetting200ResponseToJSON(value?: UpdateUserNotificationSetting200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdateUserNotificationSetting200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

